// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FN3v","right":"styles_right__2j5Q1"};